import { render, staticRenderFns } from "./ddzf.vue?vue&type=template&id=77b2f11c&scoped=true&"
import script from "./ddzf.vue?vue&type=script&lang=js&"
export * from "./ddzf.vue?vue&type=script&lang=js&"
import style0 from "./ddzf.vue?vue&type=style&index=0&id=77b2f11c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b2f11c",
  null
  
)

export default component.exports